import { FiltersQuery } from "../../../types/PreConFilterQuery.interface";
import { Popover, Transition } from "@headlessui/react";
import useDebounce from "../../../hooks/useDebounce";
import React, { Suspense, useState } from "react";
import { BiChevronDown } from "react-icons/bi";
import dynamic from "next/dynamic";

const Range = dynamic(() => import("../../../components/Range"), {
  suspense: true,
});

interface PriceFiltersProps {
  query: FiltersQuery;
  push: (query: any) => void;
}

const PriceFilters: React.FC<PriceFiltersProps> = ({ query, push }) => {
  const [price, setPrice] = useState<number[]>([0, 3000000]);

  const _changePrice = (price: number[]) => {
    push({
      price,
      page: "1",
    });
  };

  const changePrice = useDebounce(_changePrice, 1000);

  return (
    <Popover>
      <Popover.Button className="flex gap-2 justify-center items-center outline-none border-none whitespace-nowrap text-sm">
        <>
          Starting Price <BiChevronDown size={15} />
        </>
      </Popover.Button>
      <Transition
        as={React.Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <Popover.Panel className="bg-white border border-black border-opacity-5 absolute rounded-sm text-black px-3 py-2 flex flex-col gap-3 left-0 w-auto md:left-auto">
          <div className="flex justify-between items-center gap-5 flex-wrap">
            <input
              min={0}
              value={price[0] || query.price[0]}
              onChange={(min) => {
                setPrice([Number.parseInt(min.currentTarget.value), price[1]]);

                changePrice([
                  Number.parseInt(min.currentTarget.value),
                  price[1],
                ]);
              }}
              type="number"
              className="border border-black border-opacity-5 py-2 px-3 outline-none w-32"
            />
            <span className="text-gray-500">-</span>
            <input
              min={0}
              
              value={price[1] || query.price[1]}
              onChange={(max) => {
                setPrice([price[0], Number.parseInt(max.currentTarget.value)]);

                changePrice([
                  price[0],
                  Number.parseInt(max.currentTarget.value),
                ]);
              }}
              type="number"
              className="border border-black border-opacity-5 py-2 px-3 outline-none w-32"
            />
          </div>
          <div>
            <Suspense
              fallback={
                <>
                  <p>Loading...</p>
                </>
              }
            >
              <Range
                step={1000}
                min={0}
                max={3000000}
                defaultValue={price}
                onChange={async (value) => {
                  const newPrice: number[] = value as number[];

                  setPrice(newPrice);

                  changePrice(newPrice);
                }}
              />
            </Suspense>
          </div>
        </Popover.Panel>
      </Transition>
    </Popover>
  );
};

export default PriceFilters;
